<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            {{ earningType.name }}
        </template>

        <template v-slot:header>
            <div>
                <span class="text-semibold">Has been used: </span>
                <span v-if="earningType.has_been_used">Yes</span>
                <span v-if="!earningType.has_been_used">No</span>
            </div>
        </template>

        <slot>
            <div class="card mb-2">
                <div class="card-header pr-1 d-flex align-items-center">
                    <span class="btnlike mr-auto">
                        <h4 class="mb-0">Earning Type</h4>
                    </span>

                    <button class="btn btn-primary" type="button" @click.prevent="editIsOpen = true">Edit</button>
                    <!-- <button class="btn btn-outline-primary ml-1" type="button" @click.prevent="onDelete" v-if="!earningType.has_been_used">Delete</button> -->
                </div>

                <div class="card-body py-1">
                    <earning-type-details :earning-type="earningType" />
                </div>
            </div>

            <edit-modal v-if="editIsOpen" :earningType="earningType" @updated="onUpdate" @close="editIsOpen = false"/>
        </slot>
    </sidebar>
</template>

<script>
import EditModal from './EarningTypeModal'
import Sidebar from '@/components/Sidebar'
import EarningTypeDetails from './EarningTypeVersion'

export default {
    components: {EditModal, Sidebar, EarningTypeDetails},
    props: ['earningType', ],
    data() {
        return {
            editIsOpen: false,
        }
    },
    methods: {
        onDelete() {
            if (!confirm("Are you sure?")) {return}

            this.$store.dispatch('START_LOADING')
            this.$api.del(`/admin/tax-engine/earning-types/${this.earningType.id}`).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('deleted')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onUpdate($event) {
            this.$emit('updated', $event)
        },
    },
}
</script>
